/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import "./Navigation.scss";
import eventTracking from "../../utils/eventTracking";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, open: false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  render() {
    function backToStart(e) {
      e.setState((prevState) => ({ open: !prevState.open }));
      e.props.scrollToActive("intro");
    }
    function onClick(e, label) {
      e && backToStart(e);
      eventTracking(
        'Meny',
        label
      );

    }
    return (
      <div className="menu-wrapper" open={this.state.open}>
        <div className="menu">
          <div
            onClick={() => onClick(this, 'Tilbake til start')}
          >Tilbake til start</div>
          <a
            href="https://miljoskole.loop.no/barnasskog/"
            target="_blank"
            onClick={() => onClick(false, 'Ressurside')}
          >
            Ressurser til Barnas Skog
          </a>
          <a
            href="https://miljoskole.loop.no"
            target="_blank"
            onClick={() => onClick(false, 'Miljøskole')}
          >
            Miljøskole.no
          </a>
        </div>
        <div
          className="burger"
          onClick={() =>
            this.setState((prevState) => ({ open: !prevState.open }))
          }
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default Navigation;
